<template>
  <v-dialog persistent v-model="value" max-width="290">
    <v-form @submit.prevent="save">
      <v-card>
        <v-card-title class="headline">{{$t('Pages.Users.attach_sector')}}</v-card-title>

        <v-card-text>
          <v-layout column wrap>
            <v-flex xs12 md5>
              <v-autocomplete
                :search-input.sync="qSector"
                v-model="newSector.sector"
                :items="sectors"
                :loading="sectorLoading"
                v-validate="'required'"
                :error-messages="errors.first('sectors')"
                name="sectors"
                color="indigo"
                hide-no-data
                hide-selected
                item-text="name"
                item-value="id"
                :label="$t('Pages.Sectors.title_singular')"
                :placeholder="$t('Common.type_to_search')"
                prepend-icon="mdi-puzzle"
                return-object
              ></v-autocomplete>
            </v-flex>
            <v-flex xs12 md5 v-if="!isReviser">
              <v-dialog
                ref="dialogWorking"
                v-model="modalWorking"
                :return-value.sync="newSector.started_working"
                persistent
                lazy
                full-width
                width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="computedStartWorking"
                  :label="$t('Pages.Users.model.started_working')"
                  prepend-icon="event"
                  readonly
                  color="indigo"
                  name="started_working"
                  :error-messages="errors.first('started_working')"
                ></v-text-field>
                <v-date-picker locale="sr-Latn-RS" color="indigo" v-model="newSector.started_working" scrollable>
                  <v-spacer></v-spacer>
                  <v-btn flat @click="modalWorking = false">{{$t('Core.Fields.cancel')}}</v-btn>
                  <v-btn flat color="indigo" @click="$refs.dialogWorking.save(newSector.started_working)">{{$t('Core.Fields.ok')}}</v-btn>
                </v-date-picker>
              </v-dialog>
            </v-flex>
            <v-flex xs12 md5 v-if="!isReviser">
              <v-autocomplete
                :search-input.sync="qWorkplace"
                v-model="newSector.workplace"
                :items="workplaces"
                :loading="workplaceLoading"
                v-validate="'required'"
                :error-messages="errors.first('workplaces')"
                name="workplaces"
                color="indigo"
                hide-no-data
                hide-selected
                item-text="name"
                item-value="id"
                :label="$t('Pages.Workplaces.title_singular')"
                :placeholder="$t('Common.type_to_search')"
                prepend-icon="mdi-briefcase"
                return-object
              ></v-autocomplete>
            </v-flex>
          </v-layout>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn @click="close">
            {{$t('Core.Fields.close')}}
          </v-btn>

          <v-btn dark color="success dark1" type="submit">
            {{$t('Core.Fields.save')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
  import _ from 'lodash';
  export default {
  components: {},
  props: ['userId', 'value', 'isReviser'],
  data: () => ({
    newSector: {},
    qSector: null,
    modalWorking: false,
    sectors: [],
    sectorLoading: false,
    qWorkplace: null,
    workplaces: [],
    workplaceLoading: false,
  }),
  computed: {
    computedStartWorking(val){
      return this.getLocaleDateFormat(this.newSector.started_working);
    },
  },
  created () {

  },
  methods: {
    close(){
      this.newSector = {};
      this.$emit('close')
    },
    save(){
    this.$validator.validateAll().then((result) => {
        if (result) {
          if(this.isReviser){
            this.repositories.user.attachRevisedSector(this.userId, this.newSector.sector.id).then((response) => {
              this.$toast.success(response.data.message);
              this.newSector = {};
              this.$emit('refresh');
              this.close();
            });
          }
          else {
            this.repositories.user.attachSector(this.userId, this.newSector.sector.id, {workplace_id: this.newSector.workplace.id, started_working: this.newSector.started_working}).then((response) => {
              this.$toast.success(response.data.message);
              this.newSector = {};
              this.$emit('refresh');
              this.close();
            });
          }
        }
      });
    }
  },
  watch: {
    qSector: _.debounce(function(val){
      if(!val) return;
      // Items have already been loaded
      if (val.length < 2) return;

      // Items have already been requested
      if (this.sectorLoading) return;

      this.sectorLoading = true;
      this.repositories.sector.all(val).then((response) => {
        this.sectors = response.data.data;
      }).finally(() => {
        this.sectorLoading = false;
      });
    }, 500),
    qWorkplace: _.debounce(function(val){
      if(!val) return;
      // Items have already been loaded
      if (val.length < 2) return;

      // Items have already been requested
      if (this.workplaceLoading) return;

      this.workplaceLoading = true;
      this.repositories.workplace.all(val).then((response) => {
        this.workplaces = response.data.data;
      }).finally(() => {
        this.workplaceLoading = false;
      });
    }, 500),
  }
}
</script>

<style lang="scss">

</style>